// extracted by mini-css-extract-plugin
export var attachment = "_ow-a";
export var emailContainer = "_ow-4";
export var emailContentPaddedContainer = "_ow-b";
export var emailHeader = "_ow-6";
export var emailIframe = "_ow-3";
export var emailInfoIcon = "_ow-9";
export var emailShortenedSummary = "_ow-e";
export var infoDropdown = "_ow-0";
export var infoRowBoundedContent = "_ow-d";
export var internal = "_ow-5";
export var merchant = "_ow-8";
export var messageInputContainer = "_ow-h";
export var normal = "_ow-7";
export var replyCard = "_ow-f";
export var subtleButton = "_ow-1";
export var subtleButtonIconContainer = "_ow-2";
export var toggleViewRepliesButton = "_ow-c";
export var wrappingText = "_ow-g";